import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, TextField, CircularProgress, Tooltip } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { vehicleToString, notifySomething, packetStatusOptions, calibrationStatusOptions } from '../_Utils/AppDocuCommon';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import DialogPacketDetails from './DialogPacketDetails';
import DialogCalibrationDetails from './DialogCalibrationDetails';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'; // pacchetto
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined'; // elenco dati
import AddIcon from '@mui/icons-material/Add';

export default class AssocPacketCalibrationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      availablePackages: [],
      availableCalibrationsAll: [],
      assocPairs: [],
      selectedPackageId: null,
      selectedCalibrationId: null,
      detailsPackageId: null,
      detailsCalibrationId: null,  
    };
  }

  async componentDidMount() {
    await this.fetchPackagesCalibrations();
  }

  async componentDidUpdate(prevProps) {
    if (
      this.props.vehicleData &&
      (prevProps.vehicleData?.id !== this.props.vehicleData?.id || !prevProps.vehicleData && this.props.vehicleData)
    ) {
      await this.fetchPackagesCalibrations();
    }
  }

  fetchPackagesCalibrations = async () => {
    if (!this.props.vehicleData) return;
    this.setState({ loading: true });
    try {
      const [pkgs, calibs, assoc] = await Promise.all([
        AppDocuServiceCall.listPackets(),
        AppDocuServiceCall.listCalibrations(),
        AppDocuServiceCall.getVehiclePacketsCalibrations(this.props.vehicleData.id)
      ]);
      await new Promise(resolve => setTimeout(resolve, 500)); // sleep 500ms
      this.setState({
        availablePackages: pkgs.data.packages || [],
        availableCalibrationsAll: calibs.data.calibrations || [],
        assocPairs: assoc.data.packages || [],
        loading: false,
        selectedPackageId: null,
        selectedCalibrationId: null,
      });
    } catch (error) {
      notifySomething('Errore nel caricamento dei dati', 'error');
      this.setState({ loading: false });
    }
  };

  handleAddAssociation = async () => {
    const { selectedPackageId, selectedCalibrationId } = this.state;
    if (!this.props.vehicleData || (!selectedPackageId && !selectedCalibrationId)) return;
    if (!window.confirm('Sei sicuro di voler aggiungere/modificare questa associazione?')) return;
    this.setState({ loading: true });
    try {
      const res = await AppDocuServiceCall.addVehiclePacketCalibration(
        this.props.vehicleData.id,
        selectedPackageId || null,
        selectedCalibrationId || null
      );
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Errore associazione', 'error');
        this.setState({ loading: false });
        return;
      }
      await this.fetchPackagesCalibrations();
    } catch (error) {
      notifySomething('Errore associazione', 'error');
      this.setState({ loading: false });
    }
  };

  handleRemoveAssociation = async (package_id, calibration_id) => {
    if (!this.props.vehicleData) return;
    if (!window.confirm('Sei sicuro di voler rimuovere questa associazione?')) return;
    this.setState({ loading: true });
    try {
      const res = await AppDocuServiceCall.removeVehiclePacketCalibration(
        this.props.vehicleData.id,
        package_id,
        calibration_id
      );
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Errore rimozione', 'error');
        this.setState({ loading: false });
        return;
      }
      await this.fetchPackagesCalibrations();
    } catch (error) {
      notifySomething('Errore rimozione', 'error');
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading, availablePackages, availableCalibrationsAll, assocPairs, selectedPackageId, selectedCalibrationId, detailsPackageId, detailsCalibrationId } = this.state;
    const { vehicleData } = this.props;
    if (!vehicleData) return null;
    // Pacchetti e calibs per Autocomplete
    const selectedPackage = availablePackages.find(pkg => String(pkg.id) === String(selectedPackageId)) || null;
    const selectedCalibration = availableCalibrationsAll.find(calib => String(calib.id) === String(selectedCalibrationId)) || null;
    return (
      <Dialog open={!!vehicleData} onClose={this.props.onClose} maxWidth="md" fullWidth>
        <DialogTitle>
          Associate Packets/Calibrations
          {vehicleData && vehicleToString(vehicleData.id, vehicleData)}
        </DialogTitle>
        <DialogContent sx={{ overflowY: 'auto', overflow: 'visible', position: 'relative' }}>
          {loading && (
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(255,255,255,0.7)',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <CircularProgress size={48} thickness={4} />
            </div>
          )}
          <Stack spacing={2}>
            <Stack spacing={2} alignItems="center" direction="row" sx={{ width: '100%' }}>
              <Autocomplete
                fullWidth
                options={availablePackages}
                getOptionLabel={pkg => pkg?.name || ''}
                value={selectedPackage}
                onChange={(_, newValue) => this.setState({ selectedPackageId: newValue ? newValue.id : null })}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Packet (usa ; per ricerca AND)"
                    size="small"
                    disabled={loading}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <Inventory2OutlinedIcon sx={{ color: '#ff9800', mr: 1 }} />
                      ),
                      style: { borderRadius: 4 }
                    }}
                  />
                )}
                isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
                filterOptions={(options, { inputValue }) => {
                  // Supporta ricerca AND con ;
                  const searchTerms = inputValue
                    .split(';')
                    .map(s => s.trim().toLowerCase())
                    .filter(Boolean);
                  return options.filter(pkg => {
                    // Aggiungi other_accessories ai campi di ricerca
                    const accessories = (pkg.other_accessories || '').split('\n').map(s => s.trim()).filter(Boolean);
                    const fields = [pkg.name, pkg.ecu_type, pkg.kit_code, pkg.rail_code, pkg.rail2_code, ...accessories, pkg.com_brand];
                    const fullString = fields.filter(Boolean).join(' ').toLowerCase();
                    // Se ci sono più termini, tutti devono essere presenti
                    return searchTerms.every(term => fullString.includes(term));
                  });
                }}
                renderOption={(props, option) => {
                  // Prepara extraFields con other_accessories
                  const accessories = (option.other_accessories || '').split('\n').map(s => s.trim()).filter(Boolean);
                  const extraFields = [option.kit_code, option.rail_code, option.rail2_code, ...accessories]
                    .filter(Boolean)
                    .join(' / ');
                  return (
                    <li {...props} key={option.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                      <span style={{ fontWeight: 700, fontSize: 14 }}>{option.name}</span>
                      {(option.com_brand || option.ecu_type) && (
                        <span style={{ display: 'block', fontSize: 12, color: '#1976d2', fontWeight: 600, lineHeight: 1, marginTop: 0 }}>
                          {option.com_brand ? option.com_brand : ''}{option.com_brand && option.ecu_type ? ' - ' : ''}{option.ecu_type ? option.ecu_type : ''}
                        </span>
                      )}
                      <span style={{ display: 'block', fontSize: 10, color: '#888', marginTop: option.ecu_type ? 2 : 0, lineHeight: 1 }}>{extraFields}</span>
                    </li>
                  );
                }}
              />
            </Stack>
            <Stack spacing={2} alignItems="center" direction="row" sx={{ width: '100%' }}>
              <Autocomplete
                fullWidth
                options={availableCalibrationsAll}
                getOptionLabel={calib => calib?.original_filename || calib?.name || ''}
                value={selectedCalibration}
                onChange={(_, newValue) => this.setState({ selectedCalibrationId: newValue ? newValue.id : null })}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Calibration"
                    size="small"
                    disabled={loading}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <ListAltOutlinedIcon sx={{ color: '#388e3c', mr: 1 }} />
                      ),
                      style: { borderRadius: 4 }
                    }}
                  />
                )}
                isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
                filterOptions={(options, { inputValue }) => {
                  const search = inputValue.toLowerCase();
                  return options.filter(calib => {
                    const fields = [calib.original_filename, calib.name, calib.ecu_type, calib.com_brand];
                    const fullString = fields.filter(Boolean).join(' ').toLowerCase();
                    return fullString.includes(search);
                  });
                }}
                renderOption={(props, option) => (
                  <li {...props} key={option.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <span style={{ fontWeight: 700, fontSize: 14 }}>{option.original_filename}</span>
                    {(option.com_brand || option.ecu_type) && (
                      <span style={{ display: 'block', fontSize: 12, color: '#1976d2', fontWeight: 600, lineHeight: 1, marginTop: 0 }}>
                        {option.com_brand ? option.com_brand : ''}{option.com_brand && option.ecu_type ? ' - ' : ''}{option.ecu_type ? option.ecu_type : ''}
                      </span>
                    )}
                    <span style={{ display: 'block', fontSize: 10, color: '#888', marginTop: option.ecu_type ? 2 : 0, lineHeight: 1 }}>{option.name}</span>
                  </li>
                )}
              />
            </Stack>
            <Button
              onClick={this.handleAddAssociation}
              disabled={loading || (!selectedPackageId && !selectedCalibrationId)}
              variant="contained"
              color="primary"
              sx={{ minWidth: 40, minHeight: 40, px: 0, py: 0, borderRadius: 1, boxShadow: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              aria-label="Aggiungi associazione"
            >
              {/* <AddCircleIcon sx={{ color: '#fff', fontSize: 28 }} /> */}ADD
            </Button>

            <Stack spacing={1}>
              <b>Current associations:</b>
              {assocPairs.length === 0 && <span style={{ color: '#888' }}>None</span>}
              {assocPairs.map((assoc, idx) => {
                const accessories = (assoc.other_accessories || '').split('\n').map(s => s.trim()).filter(Boolean);
                const extraFields = [assoc.kit_code, assoc.rail_code, assoc.rail2_code, ...accessories]
                  .filter(Boolean)
                  .join(' / ');
                const packet_status = assoc.package_status;
                const calibration_status = assoc.calibration_status;
                return (
                  <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <IconButton size="small" color="error" onClick={() => this.handleRemoveAssociation(assoc.package_id, assoc.calibration_id)} sx={{ border: '1px solid #e57373', background: '#fff', borderRadius: 2, p: 0.5, minWidth: 28, minHeight: 28, boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
                      <span className="fa fa-trash" />
                    </IconButton>
                    {/* Packet info, if present */}
                    {assoc.package_id && (
                      <>
                        <Inventory2OutlinedIcon sx={{ color: '#ff9800', fontSize: 18, mr: 0 }} titleAccess="Packet" />
                        <IconButton size="small" title="Copia nella tendina" sx={{ fontSize: 14, ml: -0.5, p: 0 }} onClick={() => {
                          this.setState({ selectedPackageId: assoc.package_id });
                          if (navigator.clipboard) {
                            navigator.clipboard.writeText(String(assoc.package_name));
                          }
                        }}>
                          <span className="fa fa-clipboard" />
                        </IconButton>
                            {/* background color from packetStatusOptions based on assoc.package_status */}
                            {(() => {
                              const pstatus = assoc.package_status;
                              const found = packetStatusOptions.find(opt => opt.name === pstatus);
                              const borderColor = found ? found.color : '#cfcfcf';
                              return (
                                <Tooltip
                                  title={found?.name || pstatus || 'UNKNOWN'}
                                  arrow
                                  PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, -10] } }] }}
                                  componentsProps={{ tooltip: { sx: { bgcolor: borderColor, color: '#fff', '& .MuiTooltip-arrow': { color: borderColor } } } }}
                                >
                                  <span
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => this.setState({ detailsPackageId: assoc.package_id })}
                                    onKeyPress={(e) => { if (e.key === 'Enter') this.setState({ detailsPackageId: assoc.package_id }); }}
                                    style={{
                                      fontWeight: 600,
                                      cursor: 'pointer',
                                      display: 'inline-block',
                                      lineHeight: 1.1,
                                      padding: '6px 8px',
                                      borderRadius: 6,
                                      background: '#fff',
                                      border: `2px solid ${borderColor}`,
                                      color: '#222'
                                    }}
                                  >
                                    <span style={{ fontWeight: 700, fontSize: 14 }}>{assoc.package_name}</span>
                                    {(assoc.com_brand || assoc.ecu_type) && (
                                      <span style={{ display: 'block', fontSize: 12, color: '#1976d2', fontWeight: 600, lineHeight: 1, marginTop: 0 }}>
                                        {assoc.com_brand ? assoc.com_brand : ''}{assoc.com_brand && assoc.ecu_type ? ' - ' : ''}{assoc.ecu_type ? assoc.ecu_type : ''}
                                      </span>
                                    )}
                                    <span style={{ display: 'block', fontSize: 10, color: '#888', marginTop: assoc.ecu_type ? 0 : -2, lineHeight: 1 }}>{extraFields}</span>
                                  </span>
                                </Tooltip>
                              );
                            })()}
                      </>
                    )}
                    {/* Separator if both present */}
                    {assoc.package_id && assoc.calibration_id && (
                      <AddIcon sx={{ color: '#888', fontSize: 16, mx: 0.5, verticalAlign: 'middle' }} titleAccess="associato a" />
                    )}
                    {/* Calibration info, if present */}
                    {assoc.calibration_id && (
                      <>
                        <ListAltOutlinedIcon sx={{ color: '#388e3c', fontSize: 18, mr: 0 }} titleAccess="Calibration" />
                        <IconButton size="small" title="Copia nella tendina" sx={{ fontSize: 14, ml: -0.5, p: 0 }} onClick={() => {
                          this.setState({ selectedCalibrationId: assoc.calibration_id });
                          if (navigator.clipboard) {
                            navigator.clipboard.writeText(String(assoc.calibration_filename));
                          }
                        }}>
                          <span className="fa fa-clipboard" />
                        </IconButton>
                        {/* background color from calibrationStatusOptions based on assoc.calibration_status */}
                        {(() => {
                          const cstatus = assoc.calibration_status;
                          const foundc = calibrationStatusOptions.find(opt => opt.name === cstatus);
                          const borderColor = foundc ? foundc.color : '#cfcfcf';
                          return (
                            <Tooltip
                              title={foundc?.name || cstatus || 'UNKNOWN'}
                              arrow
                              PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, -10] } }] }}
                              componentsProps={{ tooltip: { sx: { bgcolor: borderColor, color: '#fff', '& .MuiTooltip-arrow': { color: borderColor } } } }}
                            >
                              <span
                                role="button"
                                tabIndex={0}
                                onClick={() => this.setState({ detailsCalibrationId: assoc.calibration_id })}
                                onKeyPress={(e) => { if (e.key === 'Enter') this.setState({ detailsCalibrationId: assoc.calibration_id }); }}
                                style={{
                                  fontWeight: 600,
                                  cursor: 'pointer',
                                  display: 'inline-block',
                                  lineHeight: 1.1,
                                  padding: '6px 8px',
                                  borderRadius: 6,
                                  background: '#fff',
                                  border: `2px solid ${borderColor}`,
                                  color: '#222'
                                }}
                              >
                                <span style={{ fontWeight: 700, fontSize: 14 }}>{assoc.calibration_filename}</span>
                                {(assoc.calibration_com_brand || assoc.calibration_ecu_type) && (
                                  <span style={{ display: 'block', fontSize: 12, color: '#1976d2', fontWeight: 600, lineHeight: 1, marginTop: 0 }}>
                                    {assoc.calibration_com_brand ? assoc.calibration_com_brand : ''}{assoc.calibration_com_brand && assoc.calibration_ecu_type ? ' - ' : ''}{assoc.calibration_ecu_type ? assoc.calibration_ecu_type : ''}
                                  </span>
                                )}
                                <span style={{ display: 'block', fontSize: 10, color: '#888', marginTop: assoc.calibration_ecu_type ? 0 : -2, lineHeight: 1 }}>{assoc.calibration_name}</span>
                              </span>
                            </Tooltip>
                          );
                        })()}
                      </>
                    )}
                    {/* Username e timestamp a destra */}
                    {(assoc.username || assoc.created_at) && (
                      <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8, fontSize: 11, color: '#555' }}>
                        {assoc.username && (
                          <span style={{ whiteSpace: 'nowrap' }}>👤 {assoc.username}</span>
                        )}
                        {assoc.created_at && (
                          <span style={{ whiteSpace: 'nowrap' }}>🕒 {new Date(assoc.created_at).toLocaleString()}</span>
                        )}
                      </span>
                    )}
                  </div>
                );
              })}
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>Close</Button>
        </DialogActions>
        <DialogPacketDetails
          showEdit={true}
          open={!!detailsPackageId}
          packageId={detailsPackageId}
          onClose={() => this.setState({ detailsPackageId: null })}
        />
        <DialogCalibrationDetails
          showEdit={true}
          open={!!detailsCalibrationId}
          calibrationId={detailsCalibrationId}
          onClose={() => this.setState({ detailsCalibrationId: null })}
        />
      </Dialog>
    );
  }
}
